import React, { useEffect, useState } from 'react'
import AdministrationLayout from '../../../../components/layouts/AdministrationLayout'
import Loader from '../../../../components/elements/Loader'
import { authHeader } from '../../../../utils'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { ERROR, SET_SUCCESS } from '../../../../store/types'
import PlusIcon from '../../../../components/elements/icons/PlusIcon'
import EmptyState from '../../../../components/elements/EmptyState'
import ModalDialog from '../../../../components/layouts/ModalDialog'
import NewBlock from '../../../../components/partials/houses/NewBlock'
import { clearCreatedHouseBlock } from '../../../../store/actions/housingActions'
import ArrowIcon from '../../../../components/elements/icons/ArrowIcon'
import { fetchStudents } from '../../../../store/actions/studentsActions'
import AssignHouseParent from '../../../../components/partials/houses/AssignHouseParent'
import StaffTableSnippet from '../../../../components/partials/staff/StaffTableSnippet'
import BlockStudentsSelection from '../../../../components/partials/houses/BlockStudentsSelection'
import TrashIcon from '../../../../components/elements/icons/TrashIcon'
import StudentCardHorizontal from '../../../../components/partials/students/StudentCardHorizontal'

const House = () => {
  const [loading, setLoading] = useState(true)
  const dispatch = useDispatch()
  const [houseDetails, setHouseDetails] = useState(null)
  const [blocks, setBlocks] = useState(null)
  const housingSelector = useSelector(state => state.housing)
  const { houseId } = useParams()
  const [reload, setReload] = useState(1);

  useEffect(() => {
    const getHouseDetails = async () => {
      try {
        const headers = authHeader()

        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/student-housing/houses/${houseId}`, { headers })            

        setHouseDetails(response.data.data)
        getBlocks()
      } catch (error) {
          console.log(error)
          dispatch({
              type: ERROR,
              error
          })
          setLoading(false)
      }
    }

    const getBlocks = async () => {
      try {
        const headers = authHeader()

        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/student-housing/house-blocks?house=${houseId}&&expand=houseParents,createdBy`, { headers })            

        setBlocks(response.data.data.blocks)
        setLoading(false)
      } catch (error) {
          console.log(error)
          dispatch({
              type: ERROR,
              error
          })
          setLoading(false)
      }
    }

    getHouseDetails()

    if(housingSelector.createdBlock !== null){
      dispatch({
        type: SET_SUCCESS,
        payload: housingSelector.createdBlock.data.message
      })
      dispatch(clearCreatedHouseBlock())
      setCreatingBlock(false)
    }

    return () => {
      
    }
  }, [houseId, housingSelector.createdBlock, dispatch, reload])

  const [creatingBlock, setCreatingBlock] = useState(false)

  const [activeBlock, setActiveBlock] = useState(null)

  const studentsSelector = useSelector(state => state.students)
  useEffect(() => {
    if(activeBlock){
      dispatch(fetchStudents(`house=${houseId}&houseBlock=${activeBlock._id}`, 0, 0))
    }

    return () => {
      
    }
  }, [activeBlock, houseId, dispatch, reload])

  const [selectingHouseParents, setSelectingHouseParents] = useState(false)
  const [selectingStudents, setSelectingStudents] = useState(false)

  const removeHouseParent = async (houseParent) => {
    
    if(!window.confirm(`Are you sure you want to remove ${houseParent.fullName} as a house parent from this house block (${houseDetails?.name} - Block ${activeBlock?.label})?`)) return
    
    try {
      const headers = authHeader()
      const payload = {
        staff: houseParent._id,
        houseBlockId: activeBlock._id
      }

      await axios.delete(`${process.env.REACT_APP_BASE_URL}/student-housing/house-blocks/remove-house-parents`, { headers, data: payload })

      dispatch({
        type: SET_SUCCESS,
        payload: 'House parent removed successfully'
      })

      setReload(reload + 1)
      setActiveBlock(null)

    } catch (error) {
      console.log('error removing house parent: ', error)
      dispatch({
        type: ERROR,
        error
      })
    }
  }
  
  return (
    <>
      <AdministrationLayout>
        <div className='w-full pb-8'>
            {loading ? 
              <Loader />
            :
              <div className='w-full'>
                <div className='flex items-center justify-between mb-[25px]'>
                  <div className='w-full grid grid-cols-4 gap-x-[50px]'>
                    <div className='w-full'>
                      <label className='text-xs text-gray-500 mb-2 block'>House Name</label>
                      <h3 className='font-medium font-space-grotesk'>{houseDetails?.name}</h3>
                    </div>
                    <div className='w-full'>
                      <label className='text-xs text-gray-500 mb-2 block'>House Gender</label>
                      <p className="capitalize">{houseDetails?.gender}</p>
                    </div>
                    <div className='w-full'>
                      <label className='text-xs text-gray-500 mb-2 block'>Colours</label>
                      <div className='flex items-center gap-x-2 mt-2'>
                        {houseDetails?.colors && houseDetails.colors.length > 0 ?
                          houseDetails.colors.map((color, colorIndex) => (
                            <div 
                              className='flex items-center gap-x-2 py-1 px-2 rounded-full bg-gray-100 border border-gray-200' 
                              
                              key={colorIndex}>
                              <div className='w-2 h-2 rounded-full' style={{backgroundColor: color.hex}} />
                              <p className='text-xs text-gray-500'>{color.name}</p>
                            </div>
                          ))
                        :
                          <p className='text-xs text-gray-400'>No colors added</p>
                        }
                      </div>
                    </div>
                  </div>
                </div>

                <div className='w-full flex items-start justify-between gap-x-[50px]'>
                  <div className='w-1/2'>
                    <div className='w-full flex items-start justify-between'>
                      <div>
                        <h3 className='mb-[5px] text-lg font-[550]'>Blocks</h3>
                        <p className='text-sm font-[500]'>Select a block to load house parents and students on the right</p>
                      </div>
                      <button onClick={()=>{setCreatingBlock(true)}} className='rounded-[8px] px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 font-space-grotesk border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-1'>
                        <PlusIcon className='w-5 h-5' />
                        Create Block
                      </button>
                    </div>

                    <div className='mt-[40px] w-full'>
                      {!blocks || blocks?.length === 0 ? 
                        <EmptyState emptyStateText={`No blocks created yet for this house. Click on "Create Block" above to create a new block`} />  
                      :
                        <div className='w-full'>
                          {blocks?.map((block, blockIndex) =>(
                            <div key={blockIndex} onClick={()=>{setActiveBlock(block)}} className={`${activeBlock?._id === block._id ? 'border-vcm-purple bg-vcm-light-purple bg-opacity-10 hover:bg-opacity-20' : 'bg-gray-50 border-transparent hover:bg-gray-100 hover:border-gray-400'} my-[20px] rounded-[8px] p-[15px]  cursor-pointer transition duration-200 border flex items-start gap-x-[10px]`}>
                              <div className='w-1/4'>
                                <label className='text-[10px] tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Block Label</label>
                                <h3 className='font-medium font-space-grotesk text-sm'>{block?.label}</h3>
                              </div>
                              <div className='w-1/4'>
                                <label className='text-[10px] tracking-[0.2em] uppercase text-gray-400 mb-2 block'>House Parents</label>
                                {block.houseParents.length === 0 ? 
                                  <p className='text-gray-400 text-xs'>No house parents assigned yet</p> : 
                                  <p className='text-sm text-gray-600'>{block.houseParents.map(parent => {return `${parent.firstName} ${parent.lastName.charAt(0)}.`}).join(',')}</p>
                                }
                              </div>
                              <div className='w-1/4'>
                                <label className='text-[10px] tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Max. Students</label>
                                <p className='font-space-grotesk text-sm'>{block.maxStudentCount}</p>
                              </div>
                              <div className='w-1/4'>
                                <label className='text-[10px] tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Current Students</label>
                                <p className='font-space-grotesk text-sm'>{block.totalStudents}</p>
                              </div>
                              <div className='w-[50px] h-[50px] flex items-center justify-center'>
                                {activeBlock?._id === block._id && 
                                  <ArrowIcon className={`w=4 h-4 text-vcm-purple transition-all duration-500`} />
                                }
                              </div>
                            </div>
                          ))}
                        </div>
                    }
                    </div>
                  </div>
                  <div className='w-1/2 min-h-[800px] h-inherit border border-gray-200 rounded-[10px] bg-gray-50 p-[30px]'>
                    {!activeBlock ? <div className='text-center'>
                      <h3 className='text-sm font-[500] mb-[5px]'>No Block Selected</h3>
                      <p className='text-sm text-gray-500 mt-[5px]'>Select a block fom the left to see full details here</p>
                    </div>
                    :
                    <div className='w-full'>
                      <div className='w-full mb-[30px] pb-[30px] border-b border-gray-300'>
                        <div className='w-full flex items-start justify-between'>
                          <div className='w-8/12'>
                            <h3 className='text-sm font-[500] mb-[5px]'>House Parents</h3>
                            <p className='text-sm'>Below are the house parents for Block {activeBlock.label}. You can have a maximum of two house parents for this block</p>
                          </div>
                          {activeBlock?.houseParents?.length < 2 && <button onClick={()=>{setSelectingHouseParents(true)}} className='rounded-[8px] px-3 py-2  text-xs text-purple-100 bg-vcm-purple transition duration-200 font-space-grotesk border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-1'>
                            <PlusIcon className='w-5 h-5' />
                            Assign a house parent
                          </button>}
                        </div>

                        {activeBlock?.houseParents?.length > 0 ? 
                          <div className='w-full mt-[20px]'>
                            {activeBlock.houseParents.map((parent, parentIndex)=>(
                              <div key={parentIndex} className='w-full flex items-start gap-x-[10px] my-[10px]'>
                                <div className='w-full bg-white p-[10px] rounded-[8px] flex items-center justify-between'>
                                  <StaffTableSnippet staff={parent} />
                                  <button onClick={()=>{removeHouseParent(parent)}} className='p-1 rounded bg-transparent mb-[10px] hover:bg-red-200 hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-red-500 flex items-center justify-center text-xs gap-x-[5px]'>
                                    <TrashIcon className={`w-4 h-4`} />
                                    Remove Parent
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        :
                          <div className='mt-[30px]'>
                            <EmptyState emptyStateText={`No House parents chosen for this block yet.`} />
                          </div>
                        }

                      </div>
                      {studentsSelector.loadingStudents ? 
                      <Loader />
                      :
                      <>
                        <div className='w-full flex items-start justify-between'>
                          <div className='w-8/12'>
                            <h3 className='text-sm font-[500] mb-[5px]'>Students</h3>
                            <p className='text-sm'>A list of students currently in Block {activeBlock.label}. You can have a maximum of {activeBlock.maxStudentCount} students for this block</p>
                          </div>
                          {<button onClick={()=>{setSelectingStudents(true)}} className='rounded-[8px] px-3 py-2  text-xs text-purple-100 bg-vcm-purple transition duration-200 font-space-grotesk border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-1'>
                            <PlusIcon className='w-5 h-5' />
                            Select Students
                          </button>}
                        </div>

                        {studentsSelector.students?.students?.length === 0 ? 
                          <div className='mt-[30px]'>
                            <EmptyState emptyStateText={`No students in this block currently.`} />
                          </div>
                        :
                          <div className='grid grid-cols-2 gap-1 mt-[20px]'>
                            {studentsSelector.students?.students?.map((student, studentIndex) => (
                              <div className='w-full' key={studentIndex}>
                                <StudentCardHorizontal student={student} />
                              </div>
                            ))}
                          </div>
                        }
                        </>
                      }
                    </div>}
                  </div>
                </div>
              </div>
            }
          </div>
      </AdministrationLayout>

      <ModalDialog
        shown={creatingBlock} 
        closeFunction={()=>{setCreatingBlock(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle={`Create a block for ${houseDetails?.name}`}
        maxWidthClass='max-w-lg'
        hideActions={true}
      >
        <NewBlock 
          houseId={houseDetails?._id}
          closeFunction={()=>{setCreatingBlock(false)}} 
          reload={()=>{setReload(reload+1)}}
        />

      </ModalDialog>

      <ModalDialog
        shown={selectingHouseParents} 
        closeFunction={()=>{setSelectingHouseParents(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle={`Select house parents for Block ${activeBlock?.label}`}
        maxWidthClass='max-w-lg'
        hideActions={true}
      >
        <AssignHouseParent 
          houseId={houseDetails?._id}
          blockId={activeBlock?._id}
          closeFunction={()=>{
            setSelectingHouseParents(false)
            setReload(reload+1)}} 
        />

      </ModalDialog>

      <ModalDialog
        shown={selectingStudents} 
        closeFunction={()=>{setSelectingStudents(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle={`Select students for Block ${activeBlock?.label}`}
        maxWidthClass='max-w-lg'
        hideActions={true}
      >
        <BlockStudentsSelection 
          houseDetails={houseDetails}
          block={activeBlock}
          reload={()=>{setReload(reload+1)}}
          closeFunction={()=>{setSelectingStudents(false)}} 
        />

      </ModalDialog>
    </>
  )
}

export default House